<sbu-overlay [configuration]="overlayConfig"></sbu-overlay>
<div #root id="root-container">
	<div id="header-container">
		<sbu-header></sbu-header>
	</div>
	<div id="content-container">
		<router-outlet></router-outlet>
	</div>
	<div id="footer-container">
		<sbu-footer></sbu-footer>
	</div>
</div>